module.exports = __webpack_public_path__ + "static/prosource-icon-512x512-180x180-5681b152acefdc95ed30dbbf81f284fe.png";